import path from 'path'
import type { StaticHandler } from '@payloadcms/plugin-cloud-storage/types'
import { getFetchURL } from '../utils.js'
import { wlodevS3Path } from '../config.js'

export const getStaticHandler = (): StaticHandler => {
    return async (
        req,
        { params: { collection, filename, clientUploadContext } }
    ) => {
        try {
            const url = getFetchURL(req.headers, path.posix.join(wlodevS3Path))
            url.searchParams.set('collection', collection)
            url.searchParams.set('key', filename)

            const res = await fetch(url, {
                method: 'GET',
                headers: new Headers({
                    cookie: req.headers.get('cookie') || '',
                }),
            })
            if (!res.ok) {
                return new Response(null, {
                    status: 404,
                    statusText: 'Not Found',
                })
            }

            // This part of etag handling is useless till we introduce the default payloadcms access control
            const blob = await res.blob()
            const etagFromHeaders =
                req.headers.get('etag') || req.headers.get('if-none-match')
            const objectEtag = res.headers.get('etag')

            if (etagFromHeaders && etagFromHeaders === objectEtag) {
                return new Response(null, {
                    headers: new Headers({
                        'Content-Length': String(blob.size),
                        'Content-Type': blob.type,
                        ETag: objectEtag,
                    }),
                    status: 304,
                })
            }

            return new Response(blob, {
                headers: new Headers({
                    'Content-Length': String(blob.size),
                    'Content-Type': blob.type,
                    ETag: objectEtag,
                }),
                status: 200,
            })
        } catch (err) {
            req.payload.logger.error({
                err,
                msg: 'Unexpected error in staticHandler',
            })
            return new Response('Internal Server Error', { status: 500 })
        }
    }
}
